import Vue from 'vue'
import VueLocalStorage from 'vue-ls'

const options = {
  namespace: 'tari_'
}

Vue.use(VueLocalStorage, options)



// WEBPACK FOOTER //
// ./src/plugins/localstorage.js